module.exports = "pegasus/assets/themelp1/launch/201.png";